







import { Vue, Component } from 'vue-property-decorator'
import Menu from './components/Menu.vue'

@Component({
  components: {
    Menu
  }
})
export default class App extends Vue {

}
